<template>
  <tr class="table__row">
    <td class="table__cell--date">{{ credit.date }}</td>
    <td class="table__cell--amount">{{ credit.orig_amount }}</td>
    <td class="table__cell--amount">{{ credit.used_amount }}</td>
    <td class="table__cell--remaining">{{ credit.remaining }}</td>
    <td class="table__cell table__cell--action"></td>
  </tr>
</template>

<script>
  export default {
    name: 'FuelFundsCredit',
    props: ['credit'],
  }
</script>
